"use client"

import { useEffect, useState } from "react"

const COUNT_KEY = "pwa-install-dismissed-count"
const AT_KEY = "pwa-install-dismissed-at"
const COOLDOWN_MS = 7 * 24 * 60 * 60 * 1000

export const useInstallBannerState = () => {
  const [hidden, setHidden] = useState(true)

  useEffect(() => {
    const count = Number(localStorage.getItem(COUNT_KEY) ?? 0)
    const at = Number(localStorage.getItem(AT_KEY) ?? 0)
    if (count >= 2) return
    if (count === 1 && Date.now() - at < COOLDOWN_MS) return
    setHidden(false)
  }, [])

  const dismiss = () => {
    const count = Number(localStorage.getItem(COUNT_KEY) ?? 0) + 1
    localStorage.setItem(COUNT_KEY, String(count))
    localStorage.setItem(AT_KEY, String(Date.now()))
    setHidden(true)
  }

  const markInstalled = () => {
    localStorage.setItem(COUNT_KEY, "2")
    setHidden(true)
  }

  return { hidden, dismiss, markInstalled }
}
